import { c as _c } from "react/compiler-runtime";
import type { PropsWithStyles } from '@morpho-org/ui-v6/types';
import { CardText } from '@morpho-org/ui-v6/server';
import React, { memo } from 'react';
import { ChartStatusRoot } from './ChartStatusRoot';
export interface ChartStatusErrorProps extends PropsWithStyles {
  borderRadius: number;
  hideBorder?: boolean;
}
function ChartStatusError(t0) {
  const $ = _c(5);
  const {
    className,
    borderRadius,
    hideBorder
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <CardText height="100%" text="Error loading chart data." />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== borderRadius || $[2] !== className || $[3] !== hideBorder) {
    t2 = <ChartStatusRoot className={className} borderRadius={borderRadius} hideBorder={hideBorder}>{t1}</ChartStatusRoot>;
    $[1] = borderRadius;
    $[2] = className;
    $[3] = hideBorder;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
export default memo(ChartStatusError);